import { makeStyles, tokens } from '@fluentui/react-components';

export const useUserMenuStyles = makeStyles({
  trigger: {
    display: 'flex',
    alignItems: 'center',
    columnGap: tokens.spacingHorizontalS,
    cursor: 'pointer',
  },
  displayName: {
    color: 'rgba(255, 255, 255, 0.9)',
    fontSize: tokens.fontSizeBase300,
  },
});
